import { SagaIterator } from "redux-saga";
import { takeLatest, put, call, select } from "redux-saga/effects";
import { getMultiPosGiftGroupsApi } from "../../../axios";
import { selectToken } from "../../selectors";
import * as actions from "../../actions";
import { getMultiPosGiftGroupsAction } from "../../../constants";

function* getMultiPosGiftGroupsSaga(): SagaIterator {
  try {
    const token = yield select(selectToken);

    const response = yield call(getMultiPosGiftGroupsApi, token);
    yield put(actions.getMultiPosGiftGroupsSuccess(response.data.data));
  } catch (e) {
    yield put(actions.getMultiPosGiftGroupsFailure(e as Error));
  }
}

export function* watchGetMultiPosGiftGroupsSaga(): SagaIterator {
  yield takeLatest(
    getMultiPosGiftGroupsAction.requested,
    getMultiPosGiftGroupsSaga
  );
}
